<template>
  <span class="line-clamp-1">
    {{ region.name ? i18n(region.name) : '' }}
    <span :class="{ 'text-[--raw-darkgrey]': region.name }">
      {{ regionCountrySuffix() }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { ArticleRegion } from '~/scopes/campaign/data/articles/types'

const props = defineProps<{ region: ArticleRegion }>()

const i18n = useI18n()

function regionCountrySuffix(): string {
  const country = i18n(props.region.country)
  return props.region.name ? ` (${country})` : country
}
</script>
